import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CNInsurance } from 'src/app/models/cninsurance';
import { BecareService } from 'src/app/services/becare.service';
import { InsuranceService } from 'src/app/services/insurance.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-e-health-assurability-dialog',
  templateUrl: './e-health-assurability-dialog.component.html',
  styleUrls: ['./e-health-assurability-dialog.component.scss']
})
export class EHealthInsurabilityDialogComponent implements OnInit {

  public insurability;
  public insurance: CNInsurance;
  public ct1 = '';
  public ct2 = '';

  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<EHealthInsurabilityDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, public patient: PatientService, private insuranceSrv: InsuranceService) {
                this.insurability = data.insurability;
              }

  ngOnInit(): void {
    this.ct1 = '';
    this.ct2 = '';
    const ct1ct2: string[] = (this.patient.patient.getProperty('Regime') == null) ? [] : this.patient.patient.getProperty('Regime').split('/');
    if (ct1ct2.length !== 0) {
      this.ct1 = ct1ct2[0];
      this.ct2 = ct1ct2[1];
    }
    this.insuranceSrv.byCode(this.insurability.mutuality).subscribe(insurance => {
      this.insurance = insurance;
    });
  }

  updatePatient(): void {
    if (this.patient.patient.insurance.code !== this.insurability.mutuality) {
      this.patient.patient.setProperty('OAID', this.insurance.id);
    }
    this.patient.patient.setProperty('Regime', this.insurability.ct1 + '/' + this.insurability.ct2);
    this.patient.patient.update().subscribe(updatePatient => {
      this.dialogRef.close();
    });
  }
}
